import type { FieldErrors } from "react-hook-form";
import type { ImageCarouselBannerInput } from "src/features/HomepageCarouselBanners/models";

import { FileUploadStep } from "src/features/vendorSponsorshipAdmin/components/FileUploadStep";
import { FormStep } from "src/features/vendorSponsorshipAdmin/components/FormStep";
import { TextInputStep } from "src/features/vendorSponsorshipAdmin/components/TextInputStep";
import LinkPickerStep from "src/components/LinkPicker/LinkPickerStep";

export interface ImageCarouselBannerFormStepListProps {
	selectedImage?: string | null;
	errors?: FieldErrors<ImageCarouselBannerInput>;
	onOpenSelectFeedModalClick?: () => void;
}

const ImageCarouselBannerFormStepList = ({
	selectedImage,
	errors,
	onOpenSelectFeedModalClick
}: ImageCarouselBannerFormStepListProps) => {
	return (
		<ul className="flex flex-col gap-4">
			<li className="w-full">
				<FormStep title="Banner name" error={errors?.name?.message}>
					<TextInputStep
						name="name"
						label="Banner name"
						placeholder="Banner name"
					/>
				</FormStep>
			</li>

			<li className="w-full">
				<FormStep
					title="Add image"
					subtitle="jpg or png, 1584 x 896px"
					error={errors?.imageUuid?.message}
				>
					<FileUploadStep
						name="imageUuid"
						fileType="image"
						imageProfile="retail-app-homepage-carousel-mobile"
						accept="image/jpeg,image/png"
						btnText={selectedImage ? "Change image" : "Upload image"}
						btnVariant={selectedImage ? "primary" : "primaryOutline"}
						btnColor={selectedImage ? "white" : "black"}
					/>
				</FormStep>
			</li>

			<li className="w-full">
				<FormStep
					title="Banner text (Optional)"
					error={
						errors?.headingText?.message || errors?.subheadingText?.message
					}
				>
					<TextInputStep
						name="headingText"
						label="Heading (optional)"
						placeholder="Maximum heading count is 40 characters."
						maxLength={40}
					/>

					<TextInputStep
						name="subheadingText"
						label="Sub heading (optional)"
						placeholder="Maximum sub heading count 40 characters."
						maxLength={40}
					/>
				</FormStep>
			</li>

			<li className="w-full">
				<FormStep
					title="Banner link (Optional)"
					error={errors?.linkType?.message}
				>
					<LinkPickerStep
						linkTypeName="linkType"
						urlName="webLink"
						feedName="feed"
						openInBrowserName="openInBrowser"
						label="Link type (optional)"
						helperText="Choose one. Switching options replaces your current selection."
					/>
				</FormStep>
			</li>
		</ul>
	);
};

export default ImageCarouselBannerFormStepList;
